export default "__VITE_ASSET__CZi8j0WJ__ 100w";